import * as React from 'react';
/**
 * The element the browser is showing full screen, or `null`.
 *
 * While an element is full screen the browser paints only its subtree, so a
 * modal, menu, confirm or toast portalled to `document.body` would open
 * invisibly behind it. Every kit portal therefore mounts into this element
 * while it is set (the Admin Configurator's full-screen board, decision Q1 of
 * the Visual Room Configurator) and back into the body when it is not.
 */
export function useFullscreenElement() {
    return React.useSyncExternalStore(subscribe, current, serverSnapshot);
}
function subscribe(onChange) {
    if (typeof document === 'undefined')
        return () => undefined;
    document.addEventListener('fullscreenchange', onChange);
    return () => document.removeEventListener('fullscreenchange', onChange);
}
function current() {
    if (typeof document === 'undefined')
        return null;
    const element = document.fullscreenElement;
    return element instanceof HTMLElement ? element : null;
}
function serverSnapshot() {
    return null;
}
//# sourceMappingURL=fullscreen.js.map